var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-entity__scoring-score flex-container",class:_vm.classObject},[(_vm.label)?_c('label',{staticClass:"c-entity__scoring-score-label flex-item-grow"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('span',{staticClass:"c-entity__scoring-score-value flex-item-no-grow"},[_vm._v(_vm._s(_vm.formatted))])])
}
var staticRenderFns = []

export { render, staticRenderFns }